export const BACK_TO_GAME_SPECIAL_SIZE_RULE = `(min-width: 667px) and (min-height: 320px) and (orientation: landscape), (min-width: 390px) and (orientation: portrait)`;
